import * as types from './actionTypes';

export function setBABusyTrue(){
  return setBillAcceptorBusy(true)
}

export function setBABusyFalse(){
  return setBillAcceptorBusy(false)
}

export function setBillAcceptorBusy(isBusy){
  return{
    type: types.SET_BILL_ACCEPTOR_BUSY,
    isBusy
  }
}

// Generate a deterministic nonce based on transaction state
// This ensures idempotency: same transaction + same bill count = same nonce
// Pure function - no storage needed since it's derived from state
export function getBillsNonce(state){
  const idtx = state.purchase.idtx
  const numBills = state.purchase.num_bills
  return `${idtx}-bill-${numBills + 1}`
}
